import React, {Component} from 'react';
import './Legend.css';


class Legend extends Component {
    constructor(props) {
        super(props);
        let datasets;
        if(this.props.typeOfChart === 'Pie') {
            datasets = [...this.props.data.legendLabels.map((label, i) => {
                return {label: label, backgroundColor: this.props.data.datasets[0].backgroundColor[i]}
            })];
        } else if(this.props.typeOfChart === 'Radar' || this.props.typeOfChart === 'CategBar'){
            datasets = [...this.props.data.legendLabels.map((label, i) => {
                return {label: label, backgroundColor: this.props.data.backgroundColor[i]}
            })];
        }
        else {
            datasets = this.props.data.datasets;
        }
        this.state = {
            datasets
        }
    }

    componentWillReceiveProps(nextProps) {
       let datasets;
       if(nextProps.typeOfChart === 'Pie') {
            datasets = [...nextProps.data.legendLabels.map((label, i) => {
                return {label: label, backgroundColor: nextProps.data.datasets[0].backgroundColor[i]}
            })];
        } else if(nextProps.typeOfChart === 'Radar' || nextProps.typeOfChart === 'CategBar'){
            datasets = [...nextProps.data.legendLabels.map((label, i) => {
                return {label: label, backgroundColor: nextProps.data.backgroundColor[i]}
            })];
        }
        else {
            datasets = nextProps.data.datasets;
        }
       this.setState({
           datasets: datasets
       })
    }

    mouseEnterHandler = (i) => {
        let index, pointIndex;
        if(this.props.typeOfChart === 'Pie' || this.props.typeOfChart === 'Radar' || this.props.typeOfChart === 'CategBar') {
            index = 0;
            pointIndex = i;
        } else {
            index = i;
            pointIndex = 0;
        }
        this.props.openTip(this.props.chartRef, index, pointIndex);
    }

    mouseLeaveHandler = (i) => {
        let index, pointIndex;
        if(this.props.typeOfChart === 'Pie' || this.props.typeOfChart === 'Radar' || this.props.typeOfChart === 'CategBar') {
            index = 0;
            pointIndex = i;
        } else {
            index = i;
            pointIndex = 0;
        }
        this.props.closeTip(this.props.chartRef, index, pointIndex);
    }

    clickHandler = (i) => {
        this.props.clickHandler(i);
    }

    render() {
        const clickable = this.props.clickable;
        return (
            <div className='Legend' id={this.props.id}>
                {this.state.datasets.map((set, i) => {
                    return clickable ? 
                        (<span className={`Legend-member clickable ${set.label === null ? 'hiddenLegend': ''}`} key={i} onMouseEnter={() => {this.mouseEnterHandler(i)}} onMouseLeave={() => {this.mouseLeaveHandler(i)}} onClick={() => this.clickHandler(i)}>
                            <Legend-color style={{backgroundColor: set.backgroundColor}}></Legend-color>
                            <Legend-label>{set.label}</Legend-label>
                        </span>)
                    : 
                        <span className={`Legend-member ${set.label === null ? 'hiddenLegend': ''}`} key={i} onMouseEnter={() => {this.mouseEnterHandler(i)}} onMouseLeave={() => {this.mouseLeaveHandler(i)}}>
                            <Legend-color style={{backgroundColor: set.backgroundColor}}></Legend-color>
                            <Legend-label>{set.label}</Legend-label>
                        </span>
                })}
            </div>
        )   
    }
}

export default Legend;


// WEBPACK FOOTER //
// ./src/components/Legend.js